import { message } from "antd";
import api from "./api";

const handleError = (error) => {
  const message =
    error.response?.data?.DisplayMessage ||
    error.response?.data?.Message ||
    error.message ||
    "Something went wrong";
  throw new Error(message);
};
const handleError1 = (error) => {
  const errorData = error.response?.data;

  // Agar backend array me errors bhej raha ho
  if (Array.isArray(errorData?.ErrorMessage)) {
    errorData.ErrorMessage.forEach((err) => {
      message.error(err); // 👈 antd error toast
    });
    return;
  }

  // Normal single message case
  const msg =
    errorData?.DisplayMessage ||
    errorData?.Message ||
    error.message ||
    "Something went wrong";

  message.error(msg);
};
export const getAgingStoreApi = async () => {
  try {
    const response = await api.get(`/StockAgingDiscount`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getMasterAgingDiscountApi = async (
  divisionCode,
  departmentCode,
) => {
  try {
    const response = await api.get(
      `/StockAgingDiscount/GetByDivision/${divisionCode}`,
      {
        params: { departmentCode },
      },
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const postMasterApi = async (payload) => {
  try {
    const response = await api.post(`/StockAgingDiscount`, {
      ...payload,
    });
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError1(error);
    return [];
  }
};
export const getMasterByIdApi = async (id) => {
  try {
    const response = await api.get(`/StockAgingDiscount/${id}`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const PutMasterApi = async (id, payload) => {
  try {
    const response = await api.put(`/StockAgingDiscount/${id}`, {
      ...payload,
    });
    return response?.data || [];
  } catch (error) {
    handleError1(error);
    return [];
  }
};
export const deleteMasterApi = async (id) => {
  try {
    const response = await api.delete(`/StockAgingDiscount/${id}`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};

////////////etewterteterrte/////////////////////

export const getAgingListApi = async (payload) => {
  try {
    const { StoreCode, divisionCode, date } = payload;
    const response = await api.get(
      `/StockAging/barcodeliquidationaging/${divisionCode}/${StoreCode}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getAllListApi = async (payload) => {
  try {
    const { StoreCode, divisionCode, date } = payload;
    const response = await api.get(
      `/StockAging/barcodeliquidationagingalllist/${divisionCode}/${StoreCode}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getLiquidationListApi = async (payload) => {
  try {
    const { StoreCode, divisionCode, date } = payload;
    const response = await api.get(
      `/StockAging/barcodeliquidationagingalllistforapprove/${divisionCode}/${StoreCode}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getFinalReportApi = async (payload) => {
  try {
    const { StoreCode, divisionCode, date } = payload;
    const response = await api.get(
      `/StockAging/barcodeliquidationagingallfinallist/${divisionCode}/${StoreCode}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};

export const updateAgingStoreApi = async (payload) => {
  try {
    const response = await api.post(
      `/StockAging/barcodeliquidationagingupdate`,
      payload,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError1(error);
    return [];
  }
};
export const approveListApi = async (payload) => {
  try {
    const response = await api.post(
      `/StockAging/barcodeliquidationagingapprove`,
      payload,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "No Data Found");
    } else {
      message.success(
        response?.data?.Data[0]?.message || "Data Fetched Successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError1(error);
    return [];
  }
};
